import { createSlice } from "@reduxjs/toolkit";
import {
    getFinanzasKpisData,
    getFinanzasEvolucionData,
    getFinanzasGastosData,
    getFinanzasSaldosData,
    getFinanzasFacturasPendientesData,
    getFinanzasFacturasPendientesMesData,
    getFinanzasParcialData,
    getFinanzasPaisesAnualData,
    getFinanzasPaisesParcialData,
    getFinanzasClientesAnualData,
    getFinanzasClientesParcialData,
    getFinanzasAgingCobrosData,
    getFinanzasDsoData,
    getFinanzasTicketMedioAnualData,
    getFinanzasTicketMedioParcialData,
    getFinanzasEficienciaData,
} from './thunk';

const initialState = {
    kpis: null,
    evolucion: null,
    gastos: null,
    saldos: null,
    facturasPendientes: null,
    facturasPendientesMes: null,
    parcial: null,
    paisesAnual: null,
    paisesParcial: null,
    clientesAnual: null,
    clientesParcial: null,
    agingCobros: null,
    dso: null,
    ticketMedioAnual: null,
    ticketMedioParcial: null,
    eficiencia: null,
    loading: {
        kpis: false, evolucion: false, gastos: false, saldos: false, facturas: false,
        facturasMes: false,
        parcial: false, paisesAnual: false, paisesParcial: false,
        clientesAnual: false, clientesParcial: false, agingCobros: false, dso: false,
        ticketMedioAnual: false, ticketMedioParcial: false, eficiencia: false,
    },
    error: null,
};

const DashboardFinanzasSlice = createSlice({
    name: 'DashboardFinanzas',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // KPIs
            .addCase(getFinanzasKpisData.pending, (s) => { s.loading.kpis = true; s.error = null; })
            .addCase(getFinanzasKpisData.fulfilled, (s, a) => { s.loading.kpis = false; s.kpis = a.payload; })
            .addCase(getFinanzasKpisData.rejected, (s, a) => { s.loading.kpis = false; s.error = a.error.message; })
            // Evolución
            .addCase(getFinanzasEvolucionData.pending, (s) => { s.loading.evolucion = true; })
            .addCase(getFinanzasEvolucionData.fulfilled, (s, a) => { s.loading.evolucion = false; s.evolucion = a.payload; })
            .addCase(getFinanzasEvolucionData.rejected, (s, a) => { s.loading.evolucion = false; s.error = a.error.message; })
            // Gastos Holded
            .addCase(getFinanzasGastosData.pending, (s) => { s.loading.gastos = true; })
            .addCase(getFinanzasGastosData.fulfilled, (s, a) => { s.loading.gastos = false; s.gastos = a.payload; })
            .addCase(getFinanzasGastosData.rejected, (s, a) => { s.loading.gastos = false; s.error = a.error.message; })
            // Saldos
            .addCase(getFinanzasSaldosData.pending, (s) => { s.loading.saldos = true; })
            .addCase(getFinanzasSaldosData.fulfilled, (s, a) => { s.loading.saldos = false; s.saldos = a.payload; })
            .addCase(getFinanzasSaldosData.rejected, (s, a) => { s.loading.saldos = false; })
            // Facturas pendientes
            .addCase(getFinanzasFacturasPendientesData.pending, (s) => { s.loading.facturas = true; })
            .addCase(getFinanzasFacturasPendientesData.fulfilled, (s, a) => { s.loading.facturas = false; s.facturasPendientes = a.payload; })
            .addCase(getFinanzasFacturasPendientesData.rejected, (s) => { s.loading.facturas = false; })
            // Facturas pendientes del mes (vista mensual)
            .addCase(getFinanzasFacturasPendientesMesData.pending, (s) => { s.loading.facturasMes = true; })
            .addCase(getFinanzasFacturasPendientesMesData.fulfilled, (s, a) => { s.loading.facturasMes = false; s.facturasPendientesMes = a.payload; })
            .addCase(getFinanzasFacturasPendientesMesData.rejected, (s) => { s.loading.facturasMes = false; })
            // Parcial (ingresos/gastos por periodo)
            .addCase(getFinanzasParcialData.pending, (s) => { s.loading.parcial = true; })
            .addCase(getFinanzasParcialData.fulfilled, (s, a) => { s.loading.parcial = false; s.parcial = a.payload; })
            .addCase(getFinanzasParcialData.rejected, (s) => { s.loading.parcial = false; })
            // Top países anual
            .addCase(getFinanzasPaisesAnualData.pending, (s) => { s.loading.paisesAnual = true; })
            .addCase(getFinanzasPaisesAnualData.fulfilled, (s, a) => { s.loading.paisesAnual = false; s.paisesAnual = a.payload; })
            .addCase(getFinanzasPaisesAnualData.rejected, (s) => { s.loading.paisesAnual = false; })
            // Top países parcial
            .addCase(getFinanzasPaisesParcialData.pending, (s) => { s.loading.paisesParcial = true; })
            .addCase(getFinanzasPaisesParcialData.fulfilled, (s, a) => { s.loading.paisesParcial = false; s.paisesParcial = a.payload; })
            .addCase(getFinanzasPaisesParcialData.rejected, (s) => { s.loading.paisesParcial = false; })
            // Top clientes anual
            .addCase(getFinanzasClientesAnualData.pending, (s) => { s.loading.clientesAnual = true; })
            .addCase(getFinanzasClientesAnualData.fulfilled, (s, a) => { s.loading.clientesAnual = false; s.clientesAnual = a.payload; })
            .addCase(getFinanzasClientesAnualData.rejected, (s) => { s.loading.clientesAnual = false; })
            // Top clientes parcial
            .addCase(getFinanzasClientesParcialData.pending, (s) => { s.loading.clientesParcial = true; })
            .addCase(getFinanzasClientesParcialData.fulfilled, (s, a) => { s.loading.clientesParcial = false; s.clientesParcial = a.payload; })
            .addCase(getFinanzasClientesParcialData.rejected, (s) => { s.loading.clientesParcial = false; })
            // Aging de cobros
            .addCase(getFinanzasAgingCobrosData.pending, (s) => { s.loading.agingCobros = true; })
            .addCase(getFinanzasAgingCobrosData.fulfilled, (s, a) => { s.loading.agingCobros = false; s.agingCobros = a.payload; })
            .addCase(getFinanzasAgingCobrosData.rejected, (s) => { s.loading.agingCobros = false; })
            // DSO contable YTD
            .addCase(getFinanzasDsoData.pending, (s) => { s.loading.dso = true; })
            .addCase(getFinanzasDsoData.fulfilled, (s, a) => { s.loading.dso = false; s.dso = a.payload; })
            .addCase(getFinanzasDsoData.rejected, (s) => { s.loading.dso = false; })
            // Ticket medio anual
            .addCase(getFinanzasTicketMedioAnualData.pending, (s) => { s.loading.ticketMedioAnual = true; })
            .addCase(getFinanzasTicketMedioAnualData.fulfilled, (s, a) => { s.loading.ticketMedioAnual = false; s.ticketMedioAnual = a.payload; })
            .addCase(getFinanzasTicketMedioAnualData.rejected, (s) => { s.loading.ticketMedioAnual = false; })
            // Ticket medio parcial
            .addCase(getFinanzasTicketMedioParcialData.pending, (s) => { s.loading.ticketMedioParcial = true; })
            .addCase(getFinanzasTicketMedioParcialData.fulfilled, (s, a) => { s.loading.ticketMedioParcial = false; s.ticketMedioParcial = a.payload; })
            .addCase(getFinanzasTicketMedioParcialData.rejected, (s) => { s.loading.ticketMedioParcial = false; })
            // Eficiencia (ratio gastos/ingresos + runway)
            .addCase(getFinanzasEficienciaData.pending, (s) => { s.loading.eficiencia = true; })
            .addCase(getFinanzasEficienciaData.fulfilled, (s, a) => { s.loading.eficiencia = false; s.eficiencia = a.payload; })
            .addCase(getFinanzasEficienciaData.rejected, (s) => { s.loading.eficiencia = false; });
    }
});

export default DashboardFinanzasSlice.reducer;
